
import { mapState, mapGetters } from "vuex";
import { Component, Vue, Watch } from "vue-property-decorator";
import SessionDetails from "./SessionDetails.vue";
import Brochure from "@/models/Brochure";

@Component({
  components: {
    SessionDetails
  },
  computed: {
    ...mapState("BrochureAanvraag", [
      "brochures",
      "studies",
      "allFilteredBrochures"
    ]),
    ...mapGetters("BrochureAanvraag", [
      "GetFilteredBrochures",
      "CurrentNumberOfPages",
      "VlsBrochures"
    ])
  }
})
export default class SessionList extends Vue {
  BrochuresPerpage = [];
  page = 1;
  totalvisible = 8;
  mobile = false;
  windowWidth = 2000;

  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth
      this.mobile = this.windowWidth < 700;
    }
  }
  created() {
    this.page = 1;
    if (this.windowWidth < 700) {
      this.totalvisible = 6;
    }
  }

  data() {
    return {
      windowWidth: window.innerWidth,
      panel: 0,
      panel2: [99],
      page: 1,
      total: 0,
      pages: 2,
      visible: 6
    };
  }

  @Watch("page")
  pageChange(pagenr: number) {

    const brochures = this.$store.state.BrochureAanvraag.allFilteredBrochures;

    this.BrochuresPerpage = brochures.slice(
      (pagenr - 1) * this.$store.state.BrochureAanvraag.sessionsOnPage,
      pagenr * this.$store.state.BrochureAanvraag.sessionsOnPage
    );
  }

  @Watch("allFilteredBrochures", { immediate: true })
  filterdParentBrochuresChanged() {
    this.page = 1;
    this.pageChange(1);
  }
}
